var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatePrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.002 19H5.00195C4.47152 19 3.96281 18.7893 3.58774 18.4142C3.21267 18.0391 3.00195 17.5304 3.00195 17V6.99998C3.00195 6.46955 3.21267 5.96084 3.58774 5.58577C3.96281 5.2107 4.47152 4.99998 5.00195 4.99998H19.002C19.5324 4.99998 20.0411 5.2107 20.4162 5.58577C20.7912 5.96084 21.002 6.46955 21.002 6.99998V13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00195 6.99997L12.002 13L21.002 6.99997M16.002 22L21.002 17M21.002 17V21.5M21.002 17H16.502",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePrIcon);
export default __webpack_public_path__ + "static/media/create-pr-icon.b0123755e9ad6734001f87f81fe72364.svg";
export { ForwardRef as ReactComponent };